import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Coins, ArrowUpRight, ArrowDownLeft, Info } from "lucide-react";
import CoinCard from "@/components/CoinCard";

export default function Wallet() {
  const { user } = useAuth();
  const [txns, setTxns] = useState([]);
  useEffect(() => { api.get("/tokens/transactions").then((r) => setTxns(r.data)).catch(() => {}); }, []);

  if (!user) return null;

  return (
    <div className="max-w-3xl mx-auto px-5 md:px-8 py-12">
      <div className="bg-gradient-to-br from-[#6A0DAD] to-[#58098F] rounded-2xl p-8 text-white shadow-lg">
        <p className="font-heading text-sm uppercase tracking-widest opacity-80">Community AMIR Points</p>
        <div className="flex items-center gap-3 mt-2">
          <Coins size={36} className="text-[#F0D67A]" />
          <span className="font-display text-6xl">{user.amir_balance}</span>
          <span className="font-heading text-xl opacity-80 self-end mb-2">AMIR</span>
        </div>
        <p className="mt-3 text-sm opacity-90 font-heading">Kindness points you share with families right here in the community.</p>
      </div>

      <div className="mt-4 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-2xl p-5 flex gap-3">
        <Info size={20} className="text-[#B8972E] shrink-0 mt-0.5" />
        <p className="text-sm text-[#4A5568] leading-relaxed">
          These community points let you thank families for their help. They're separate from the
          on-chain <span className="font-semibold">AMIR</span> coin below, which lives on Solana.
        </p>
      </div>

      <h2 className="font-heading text-lg font-semibold text-[#1A202C] mt-8 mb-4">The official AMIR coin</h2>
      <CoinCard />

      <h2 className="font-heading text-lg font-semibold text-[#1A202C] mt-8 mb-4">Community points history</h2>
      <div className="space-y-3">
        {txns.length === 0 && (
          <div className="bg-white border border-[#6A0DAD] rounded-2xl p-10 text-center text-[#4A5568]">No transactions yet.</div>
        )}
        {txns.map((t) => {
          const incoming = t.to_id === user._id;
          return (
            <div key={t._id} data-testid={`txn-${t._id}`} className="bg-white border border-[#6A0DAD] rounded-2xl p-5 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <span className={`grid place-items-center w-10 h-10 rounded-full ${incoming ? "bg-green-100 text-green-600" : "bg-[#6B8EAC]/12 text-[#6B8EAC]"}`}>
                  {incoming ? <ArrowDownLeft size={18} /> : <ArrowUpRight size={18} />}
                </span>
                <div>
                  <p className="font-heading font-semibold text-[#1A202C]">
                    {incoming ? `From ${t.from_name}` : `To ${t.to_name}`}
                  </p>
                  {t.note && <p className="text-sm text-[#4A5568]">"{t.note}"</p>}
                  <p className="text-xs text-[#4A5568]">{new Date(t.created_at).toLocaleString()}</p>
                </div>
              </div>
              <span className={`font-heading font-bold ${incoming ? "text-green-600" : "text-[#B8972E]"}`}>
                {incoming ? "+" : "−"}{t.amount}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
